'use strict';

var CreateNetworkObject = require('actionGroups/createNetworkObject/CreateNetworkObject');

module.exports = {
  Model: CreateNetworkObject,
};
